"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsDataBucketSyncActionType = void 0;
/**
 * Reducer-style actions for updating and restoring client state.
 *   Sent from backend/src/services/data-bucket-def/data-bucket-with-redis-hash.ts
 *   Data used in frontend/src/state/ws-client-subscription/ws-data-bucket.ts
 * Each is used as the "type" of a ClientReducerAction.
 *
 * note: SetItem and DeleteItem use SingleItemReducerAction types for their actionData, explicitly sending key and value
 *  attrib fields. ResetStore sends a single object that resets state, of type Record<string, any>.
 *
 */
var WsDataBucketSyncActionType;
(function (WsDataBucketSyncActionType) {
    /**
     * Reset the entire bucket/cache state with the newly supplied Record data
     */
    WsDataBucketSyncActionType["ResetStore"] = "ResetStore";
    /**
     * Updates multiple items on the bucket/cache, assigning all items present on payload to bucket state
     */
    WsDataBucketSyncActionType["UpdateItems"] = "UpdateItems";
    /**
     * Updates state for a single item, setting key & value pair on the bucket/cache
     */
    WsDataBucketSyncActionType["SetItem"] = "SetItem";
    /**
     * Deletes each item key listed in payload
     */
    WsDataBucketSyncActionType["DeleteItems"] = "DeleteItems";
})(WsDataBucketSyncActionType = exports.WsDataBucketSyncActionType || (exports.WsDataBucketSyncActionType = {}));
//# sourceMappingURL=ws-client-sync-interfaces.js.map